import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

interface QRCodeCardProps {
  paymentLink: string;
  amount: number;
}

const QRCodeCard: React.FC<QRCodeCardProps> = ({ paymentLink, amount }) => {
  return (
    <div className="bg-green-600 bg-opacity-10 rounded-lg p-6 shadow-md border border-green-600 border-opacity-30 text-center">
      <div className="inline-block p-4 bg-background rounded-lg shadow-inner">
        <QRCodeSVG value={paymentLink} size={180} level="H" includeMargin />
      </div>
      <p className="mt-4 text-green-900 text-sm font-bold">
        Scan to pay{' '}
        <span className="font-bold">${amount.toFixed(2)}</span>
      </p>
    </div>
  );
};

export default QRCodeCard;

